<div class="page-wrapper section-hr-direct">

  <app-left-menu></app-left-menu>


  <div id="main-container">
    <app-header [showHistoryButton]="false" [title]="title"></app-header>

    <div class="content-header">

    </div>
    <div class="page-content settings">
      <div class="content-mid no-absolute">


        <div class="link-blocks m-t75">



          <ul class="md-block-grid-2 xs-block-grid-1 " style="margin-top:25px">
            <li>
              <a [routerLink]="['/managepractice/locations']" routerLinkActive="router-link-active"
                routerLinkActive="router-link-active"
                class="item employees">{{'ManagePractice.Menus.Locations'|translate}}</a>
            </li>
            <li>
              <a [routerLink]="['/managepractice/practiceinformation']" routerLinkActive="router-link-active"
                routerLinkActive="router-link-active"
                class="item hrinfo">{{'ManagePractice.Menus.PracticeInformation'|translate}}</a>
            </li>
            <li *ngIf="isIndividualProvider=='True'">

              <a [routerLink]="['/managepractice/licenseandliability']" routerLinkActive="router-link-active"
                routerLinkActive="router-link-active" class="item brochures">
                <span>
                  <!--Batch for Benefit Notifications-->

                  <i class="licenseandliability landing-badge "></i>
                </span>
                {{'ManagePractice.Menus.LicenseLiability'|translate}}

              </a>

            </li>
            <li *ngIf="isIndividualProvider=='False'">
              <a [routerLink]="['/managepractice/counselors']" routerLinkActive="router-link-active"
                routerLinkActive="router-link-active"
                class="item benefits">{{'ManagePractice.Menus.PracticeCounselors'|translate}}</a>

            </li>

          </ul>
        </div>
        <div>
          <div class="legend-warning" style=" display: none; margin-left: 40px;">
            <i class="licenseandliability legend-main-warning-badge" style="display: inline-block;"></i>
            <label>{{'Common.WarningBadgeMessage'|translate}}</label></div>
          <div class="legend-alert" style=" display: none;  margin-top:20px; margin-left: 40px;">
            <i class="licenseandliability legend-main-alert-badge" style="display: inline-block;"></i>
            <label>{{'Common.AlertBadgeMessage'|translate}}</label></div>
        </div>

      </div>
    </div>
  </div>
</div>